import { render, staticRenderFns } from "./ColoredButton.vue?vue&type=template&id=6e112ff5&scoped=true"
import script from "./ColoredButton.vue?vue&type=script&lang=js"
export * from "./ColoredButton.vue?vue&type=script&lang=js"
import style0 from "./ColoredButton.vue?vue&type=style&index=0&id=6e112ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e112ff5",
  null
  
)

export default component.exports